import * as queryString from 'query-string';
import React from 'react';
import { Route, RouteComponentProps } from 'react-router-dom';

import { Helpers } from '~commonInfra/utils/Helpers';
import { SigninErrorPage } from '~src/authentication/components/SigninErrorPage';
import { AuthenticationService } from '~src/authentication/services/AuthenticationService';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';

import { RouterError } from '../../../bootstrap/routerHelpers/RouterError';
import { DefaultServerTitleWrapper } from './DefaultServerTitleWrapper';
import { LoginUrlsWrapper } from './LoginUrls';
import { SignInLogo } from './SignInLogo';

export interface SpaceRouteParams {
  readonly errorCode: string;
}
export interface SigninErrorRouteComponentProps extends RouteComponentProps<SpaceRouteParams> { }

export interface LoginErrorProviderProps {
  readonly urls: SpacesSiteUrls;
}

interface LoginErrorProviderState {
  doesTheCurrentUserBelongToMoreThanOneSite: boolean;
}

export class LoginErrorProvider extends React.Component<LoginErrorProviderProps, LoginErrorProviderState> {

  constructor(props: LoginErrorProviderProps) {
    super(props);
    this.state = {
      doesTheCurrentUserBelongToMoreThanOneSite: true,
    };
  }

  public render() {
    return (
      <DefaultServerTitleWrapper>
        <div className="tb-error-box tb-error-no-site">
          <SignInLogo />
          <Route exact path={LoginUrlsWrapper.getInstance().signinErorrCodePath(':errorCode')} render={this.errorCodeProvider()} />
          <Route exact path={LoginUrlsWrapper.getInstance().signinAuthErorrPath(':errorCode')} render={this.authErrorProvider()} />
        </div>
      </DefaultServerTitleWrapper>
    );
  }

  public componentDidMount() {
    AuthenticationService.doesTheCurrentUserBelongToMoreThanOneSite().then((belongsToMoreThanOneSite: boolean) => {
      this.setState({
        doesTheCurrentUserBelongToMoreThanOneSite: belongsToMoreThanOneSite,
      });
    }).catch(() => {
      // If it fails, we just say they do and let them navigate to the site-picker.
      this.setState({
        doesTheCurrentUserBelongToMoreThanOneSite: true,
      });
    });
  }

  private authErrorProvider = (): (props: SigninErrorRouteComponentProps) => JSX.Element => {
    return (props: SigninErrorRouteComponentProps): JSX.Element => {
      const queryValues = queryString.parse(props.location.search);
      return(
        <div>
          <SigninErrorPage
            errorCode={props.match.params.errorCode}
            redirectPath={queryValues['redirectPath']?? '/'} />
        </div>
      );
    };
  };

  private errorCodeProvider = (): (props: SigninErrorRouteComponentProps) => JSX.Element => {
    return (props: SigninErrorRouteComponentProps): JSX.Element => {
      const queryValues = queryString.parse(props.location.search);
      const errorCode = props.match.params.errorCode;
      const fromSiteSwitch = Helpers.BooleanQueryParamRegex.test(queryValues['fromSiteSwitch']);
      if (fromSiteSwitch) {
        // This only happens when you load a URL of a site that you are not a memeber of.
        if (this.state.doesTheCurrentUserBelongToMoreThanOneSite) {
          return <RouterError code={errorCode} errorType="no-site-multi-site-user" urls={this.props.urls}/>;
        } else {
          return <RouterError code={errorCode} errorType="no-site-single-site-user" urls={this.props.urls}/>;
        }
      } else {
        return <RouterError code={errorCode} errorType="code" urls={this.props.urls}/>;
      }
    };
  };
}
